(function() {
  var CART_DRAWER_SELECTOR = "#cart-drawer";
  var UPSELL_SOURCE_SELECTOR = "[data-ga4-upsell-source]";
  var QUICK_BUY_MODAL_SELECTOR = "quick-buy-modal";

  function centsToDecimal(value) {
    var cents = Number(value);

    if (!Number.isFinite(cents)) {
      return 0;
    }

    return Math.round(cents) / 100;
  }

  function getCurrency(cart, sourceElement) {
    return cart && cart.currency || sourceElement && sourceElement.dataset.ga4Currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "AUD";
  }

  function compactItem(item) {
    return Object.keys(item).reduce(function(compactedItem, key) {
      if (item[key] !== void 0 && item[key] !== null && item[key] !== "") {
        compactedItem[key] = item[key];
      }

      return compactedItem;
    }, {});
  }

  function getItemPrice(item) {
    if (item.final_price !== void 0 && item.final_price !== null) {
      return item.final_price;
    }

    return item.price;
  }

  function buildGa4Item(item, source, itemListName) {
    var quantity = Number(item.quantity) || 1;
    var price = centsToDecimal(getItemPrice(item));

    return compactItem({
      item_id: item.sku || String(item.variant_id || item.id || item.product_id || ""),
      item_name: item.product_title || item.title || item.handle || "",
      item_variant: item.variant_title,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_list_id: source,
      item_list_name: itemListName,
      price: price,
      quantity: quantity,
      upsell_source: source
    });
  }

  function getUpsellContext(element) {
    var sourceElement = element && element.closest && element.closest(UPSELL_SOURCE_SELECTOR);

    if (sourceElement) {
      return {
        element: sourceElement,
        source: sourceElement.dataset.ga4UpsellSource,
        itemListName: sourceElement.dataset.ga4ItemListName || sourceElement.dataset.ga4UpsellSource
      };
    }

    var modal = element && element.closest && element.closest(QUICK_BUY_MODAL_SELECTOR);

    if (modal && modal.dataset.ga4UpsellSource) {
      return {
        element: modal,
        source: modal.dataset.ga4UpsellSource,
        itemListName: modal.dataset.ga4ItemListName || modal.dataset.ga4UpsellSource
      };
    }
  }

  function getControlledModal(sourceElement, modalId) {
    var localModal = sourceElement.querySelector('[id="' + modalId.replace(/"/g, '\\"') + '"]');

    return localModal || document.getElementById(modalId);
  }

  function captureQuickBuyUpsellContext(event) {
    var button = event.target && event.target.closest && event.target.closest("[aria-controls]");

    if (!button || !button.closest(CART_DRAWER_SELECTOR)) {
      return;
    }

    var sourceElement = button.closest(UPSELL_SOURCE_SELECTOR);
    var modalId = button.getAttribute("aria-controls");

    if (!sourceElement || !modalId) {
      return;
    }

    var modal = getControlledModal(sourceElement, modalId);

    if (!modal || !modal.matches(QUICK_BUY_MODAL_SELECTOR)) {
      return;
    }

    var cartDrawer = button.closest(CART_DRAWER_SELECTOR);

    modal.dataset.ga4UpsellSource = sourceElement.dataset.ga4UpsellSource;
    modal.dataset.ga4ItemListName = sourceElement.dataset.ga4ItemListName || sourceElement.dataset.ga4UpsellSource;
    modal.dataset.ga4Currency = cartDrawer && cartDrawer.dataset.ga4Currency || "";
  }

  function trackCartDrawerUpsellAdd(event) {
    var form = event.target instanceof HTMLFormElement ? event.target : event.target && event.target.closest && event.target.closest("form");

    if (!form) {
      return;
    }

    var upsellContext = getUpsellContext(form);

    if (!upsellContext || !upsellContext.source) {
      return;
    }

    var items = event.detail && event.detail.items;

    if (!Array.isArray(items) || items.length === 0) {
      return;
    }

    var source = upsellContext.source;
    var itemListName = upsellContext.itemListName;
    var ga4Items = items.map(function(item) {
      return buildGa4Item(item, source, itemListName);
    }).filter(function(item) {
      return item.item_id || item.item_name;
    });

    if (ga4Items.length === 0) {
      return;
    }

    var value = ga4Items.reduce(function(total, item) {
      return total + item.price * item.quantity;
    }, 0);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "add_to_cart",
      cart_context: "cart_drawer",
      upsell_source: source,
      ecommerce: {
        currency: getCurrency(event.detail && event.detail.cart, upsellContext.element),
        value: Number(value.toFixed(2)),
        items: ga4Items
      }
    });
  }

  document.addEventListener("click", captureQuickBuyUpsellContext, true);
  document.addEventListener("variant:add", trackCartDrawerUpsellAdd);
})();
